var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('van-button',{attrs:{"type":"info"},on:{"click":_vm.selectFile}},[_vm._v("选择文件")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }